import React, { useState } from 'react';
import RangeSliderBox from '../../components/box/RangeSliderBox';
import styled from 'styled-components';
import { SERVER_URL } from '../../constants/url';



// 설문지 척도 컨퍼넌트
const ContentWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: var(--sp-32);
`;

const QuestionTitle = styled.p`
    font-size: var(--mo-fz-md);
    font-weight: var(--fz-weight-700);
    color: var(--color-main-gray);
    white-space: pre-wrap;
    text-align: center;
    padding: var(--sp-10) var(--sp-16);
    & strong {
        font-weight: var(--fz-weight-700);
        color: var(--color-main-black);
    }
`;

const SliderBox = styled.div`
    display: block;
    width: 100%;
    padding: 0 var(--sp-16);
    & .step-type-box-a {
        width: 100%;
    }
`;


const ImgBoxCont = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: var(--sp-28);
    padding: 0 var(--sp-16);
        & div {
            overflow: hidden;
            width: 100%;
            border-radius: var(--radius-12);
            & img {
                display: block;
                width: 100%; 
                object-fit: contain;
            }
        }
`;


const Boundary = styled.div`
    display: flex; 
    align-items: center; 
    justify-content: center; 
    position: relative;
    width: 100%;
    height: var(--sp-28);
    margin-top: var(--sp-32);
    margin-bottom: var(--sp-14);
    border-top: 1px solid var(--color-main-15);
    background-color: var(--color-main-25);

    &:before {
        content: "";
        position: absolute;
        top: 100%;
        left: 50%; 
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 20px solid transparent;
        border-right: 20px solid transparent;
        border-top: 8px solid var(--color-main-25);
    }
    
    & span {
        font-size: var(--mo-fz-sm);
        color: var(--color-main-65);
        font-weight: var(--fz-weight-700);
    } 
`;


const CostomSurveyScale = ({surveyData, selectedValue, onChange, step, stepByStep }) => {
    const { qesitmNo, qesitmCn, scalBgnVal, scalEndVal, qestAtchFileStr, qestAtchFileStrSub } = surveyData;

    //const maxValue = scalEndVal;

    //no-imgage 관련
    const [imgError, setImgError] = useState(false);

    const BoldText = ({ text }) => {

        // text가 문자열인지 확인
        if (!text || typeof text !== 'string') {
            return null;
        }
        const parts = text.split(/(\*[^*]+\*)/g);

        return (
            <>

                {parts.map((part, idx) => {
                    if (part.startsWith('*') && part.endsWith('*')) {
                        const boldText = part.slice(1, -1);
                        return <strong key={idx}>{boldText}</strong>;
                    }

                    return part.split('\n').map((line, i) => (
                        <React.Fragment key={`${idx}-${i}`}>
                            {line}
                            {i < part.split('\n').length -1 && <br />}
                        </React.Fragment>
                    ));
                })}
            </>
            );
    };

    // 노이미지 핸들러 
    const handleMainImageError = () => {
        setImgError(true);
    };


    return (
        <ContentWrap>

            <QuestionTitle>
                <BoldText text={qesitmCn} />
            </QuestionTitle>

            { qestAtchFileStrSub !== undefined && (
                <ImgBoxCont className='imgbox'>
                    <div>
                        {imgError ? (
                                <img
                                    src={`/images/common/no_img.png`}
                                    alt={`no-img`}
                                />    
                            ) : (
                                <img
                                    src={`${SERVER_URL}/cmm/fms/getImage?atchFileStr=${qestAtchFileStr}&fileSn=${qestAtchFileStrSub}`}
                                    alt={`option-${qesitmCn}`}
                                    onError={handleMainImageError} 
                                />
                            )
                        }
                    </div>

                </ImgBoxCont>
            )}

            <Boundary>
                <span>답변 선택</span>
            </Boundary>

            <SliderBox>
            <div className='step-type-box-a'>
                <div className='slider-wrap' data-type='b'>
                    <RangeSliderBox
                        value={selectedValue !== undefined ? Number(selectedValue.value) : 0}
                        onChange={(val) => {
                            onChange({ target: { qesitmSeCd: 'C' } }, val, qesitmNo);
                        }}
                        minValue={scalBgnVal ? scalBgnVal : 0}
                        maxValue={scalEndVal ? scalEndVal : 8}
                        stepByStep={stepByStep}
                    />
                </div>
            </div>
            </SliderBox>

         </ContentWrap>
    );
};

export default CostomSurveyScale;
